import { useQuery } from '@tanstack/react-query';

import { countriesWeSellMembership } from '../graphql/countriesWeSellMembership';
import { CountryWeSellTo } from '../types';

export const useGetSellToCountries = (isEnabled = true) =>
  useQuery<CountryWeSellTo[]>({
    queryKey: ['countriesWeSellMembership'],
    queryFn: async () => {
      const response = await countriesWeSellMembership();
      return response.countriesWeSellMembership;
    },
    retry: false,
    staleTime: Infinity,
    gcTime: 1000 * 60 * 60 * 24 * 7, // 7 days
    enabled: isEnabled,
  });
